import { Box, Flex, Heading, Text, IconButton, HStack, Spacer  } from '@chakra-ui/react'
import { GoSearch, GoChevronDown, GoChevronUp  } from 'react-icons/go'
import { useState } from 'react';

const SearchBox = ({primaryActions,secondaryActions}) => {

    const [isOpen, setIsOpen] = useState(false);
    const toggleBox = () => setIsOpen(!isOpen);

    return (
        <Box borderWidth="1px" borderColor="gray.300" rounded="8" mt={7}>
            <Box px={5} py={5}>
                        <HStack spacing={4}>
                            <GoSearch size="20px"/>                           
							<Heading as="h3" fontWeight="700" fontSize="20px">
								Search
							</Heading>
                            <Spacer />
                            {/* <GoChevronDown size="25px" /> */}
                            <Box as="button" onClick={toggleBox}>
                                {isOpen ? <GoChevronUp size="25px" /> : <GoChevronDown size="25px" />}
                            </Box>
                        </HStack>
            </Box>
            {isOpen && (
                <Box px={5} pb={5}>
                    {/* You can put your dynamic content here */}
                    <Box  mt={5}>
                        {/* <Text>Expanded content goes here</Text> */}
                        {primaryActions && <Flex gap={2} align="center">{primaryActions}</Flex>}
                        
                        {/* Secondary filter dropdowns below */}
                        {secondaryActions && <Box pt={5}>{secondaryActions}</Box>}
                    </Box>
                </Box>
            )}
        </Box>
    );
}

export default SearchBox;